import { FollowStateEnum } from '../enum/follow-state-enum';
import { UserTypeEnum } from '../enum/user-type-enum';
export class CustomerModel {
    constructor() {
        this.userIsAdmin = false;
        this.userIsAuthor = false;
        this.userIsLibrarian = false;
        this.userIsBlogger = false;
        this.userIsPublisher = false;
    }
    [key: string]: any
    favoritBooksGenres?: string[];
    objectTypeId?: UserTypeEnum;
    interests?: string[];
    id?: string;
    firstName?: string;
    fullName?: string;
    lastName?: string;
    uniqeName?: string;
    phoneNumber?: string;
    bio?: string;
    hasPhoto?: boolean;
    hasWallpaper?: boolean;
    birthDay?: string;
    birthMonth?: string;
    birthYear?: string;
    city?: string;
    cityId?: number;
    countery?: string;
    counteryId?: number;
    location?: string;
    address?: string;
    email?: string;
    myFollowState?: FollowStateEnum;
    visibility?: number;
    createdAt?: string;
    image?: string;
    roleNames?: string;
    userIsAdmin?: boolean = false;
    userIsAuthor?: boolean = false;
    isAuthorConnected?: boolean = false;
    userIsLibrarian?: boolean = false;
    userIsBlogger?: boolean = false;
    userIsPublisher?: boolean = false;
    gender?: number;
    inviteCode?: string;
    followersCount?: number;
    followingsCount?: number;
    ratesCount?: number;
    reviewsCount?: number;
    bookListCount?: number;
    hasFollowRequest?: boolean;

    lastSyncContactDate?: string;
    isLastSyncContactDate?: boolean;

    remainEmailChangeCount?: number;
    remainPhoneNumberChangeCount?: number;

    website?: string;
    activityScope?: string;
    description?: string
}

export class searchedUser {
    email?: string;
    firstName?: string;
    id?: string;
    lastName?: string;
    phoneNumber?: string;
    uniqeName?: string;
    image?: string;
    myFollowState?: FollowStateEnum;
    followersCount?: number;
    hasPhoto?: boolean;
    hasWallpaper?: boolean;
    roleNames?: string;
}

export class activeUserModel {
    id?: string;
    type?: number;
    fullName?: string;
    userName?: string;
    myFollowStateWith?: number;
    myFollowState?: number;
    followerCount?: number;
    hasPhoto?: boolean;
    objectTypeId?: number;
    objectId?: string;
    uniqeName?: string;
    userIsAuthor?: boolean;

    folowerCount?: number;
    hasWallpaper?: boolean;
}

export class profileType {
    id!: string;
    type!: number
}

export class UserIdentityState {
    isPublisher!: boolean;
    isAuthor!: boolean;
    id!: string;
    isUser!: boolean

}
